import { PriceRoundingRuleConfig } from '@retail/rounding/types';
import React from 'react';
import { IconButton, Stack, Tooltip } from '@mui/material';
import PriceChangeOutlinedIcon from '@mui/icons-material/PriceChangeOutlined';
import { useRoundingTFunction } from '@retail/rounding/i18n';
import { PriceRoundingConfigTable } from './PriceRoundingConfigTable';
import { PriceRoundingActionsMenu } from './PriceRoundingActionsMenu';

interface Props {
  priceRoundingConfigs: PriceRoundingRuleConfig[];
  onOpenView: (priceRoundingConfig: PriceRoundingRuleConfig) => void;
  onCopy?: (priceRoundingConfig: PriceRoundingRuleConfig) => void;
  onEdit?: (priceRoundingConfig: PriceRoundingRuleConfig) => void;
  onDelete?: (priceRoundingConfig: PriceRoundingRuleConfig) => void;
  renderHeading: (priceRoundingConfig: PriceRoundingRuleConfig) => React.ReactNode;
}

export const PriceRoundingConfigsList: React.FC<Props> = ({
  priceRoundingConfigs,
  onOpenView,
  onCopy,
  onEdit,
  onDelete,
  renderHeading,
}) => {
  const t = useRoundingTFunction();

  return (
    <Stack spacing={2} sx={{ '>:nth-of-type(odd)': { bgcolor: 'grey.50' } }}>
      {priceRoundingConfigs.map((ruleSetConfig) => (
        <Stack key={ruleSetConfig.id} px={6}>
          <Stack
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ px: 3, pt: 2 }}
          >
            <Stack>{renderHeading(ruleSetConfig)}</Stack>
            <Stack direction="row" alignItems="center">
              <Tooltip title={t('rounding.simulation.title')} placement="top">
                <IconButton onClick={() => onOpenView(ruleSetConfig)} color="primary" size="small">
                  <PriceChangeOutlinedIcon sx={{ width: 32, height: 32 }} />
                </IconButton>
              </Tooltip>
              <Tooltip title={t('rounding.actions.menu')} placement="top">
                <div>
                  <PriceRoundingActionsMenu
                    onCopy={onCopy ? () => onCopy(ruleSetConfig) : undefined}
                    onEdit={
                      onEdit && ruleSetConfig.isEditable() ? () => onEdit(ruleSetConfig) : undefined
                    }
                    onDelete={
                      onDelete && ruleSetConfig.isDeletable()
                        ? () => onDelete(ruleSetConfig)
                        : undefined
                    }
                  />
                </div>
              </Tooltip>
            </Stack>
          </Stack>

          <PriceRoundingConfigTable ruleRanges={ruleSetConfig.ranges} />
        </Stack>
      ))}
    </Stack>
  );
};
